import React from 'react';
import styled from 'styled-components';
import { spacing, fontWeight } from '../../styles/theme';
import BackButton from '../components/BackButton';

const Container = styled.div`
  height: 100vh;
  background-color: ${props => props.theme.colors.background};
  overflow: hidden;
`;

const Content = styled.div`
  height: calc(100vh - 52px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0 ${spacing.lg} ${spacing.xl};
  max-width: 480px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 0 ${spacing.md} ${spacing.xl};
  }
`;

const Header = styled.div`
  padding: 80px 0 ${spacing.lg};

  h1 {
    font-size: 28px;
    font-weight: ${fontWeight.bold};
    color: ${props => props.theme.colors.text};
    margin: 0;
    letter-spacing: -0.02em;
  }
`;

const InfoBanner = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 14px 16px;
  background: rgba(249, 115, 22, 0.08);
  border: 1px solid rgba(249, 115, 22, 0.2);
  border-radius: 12px;
  margin-bottom: 28px;
  font-size: 14px;
  line-height: 1.55;
  color: ${props => props.theme.colors.text};
`;

const Card = styled.div`
  background: ${props => props.theme.colors.surface};
  border-radius: 14px;
  border: 1px solid ${props => props.theme.mode === 'light' ? props.theme.colors.border : 'transparent'};
  overflow: hidden;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  padding: 14px 16px;
  gap: 12px;
  &:not(:last-child) {
    border-bottom: 1px solid ${props => props.theme.mode === 'light' ? props.theme.colors.border : 'rgba(255,255,255,0.05)'};
  }
`;

const RowLabel = styled.div`
  font-size: 13px;
  font-weight: ${fontWeight.semibold};
  color: ${props => props.theme.colors.muted};
  opacity: 0.7;
  min-width: 80px;
`;

const RowValue = styled.div`
  font-size: 14px;
  color: ${props => props.theme.colors.text};
  flex: 1;
`;

const EmailLink = styled.a`
  color: #f97316;
  text-decoration: none;
  font-size: 14px;
  &:hover { text-decoration: underline; }
`;

const SectionLabel = styled.div`
  font-size: 11px;
  font-weight: ${fontWeight.semibold};
  color: ${props => props.theme.colors.muted};
  text-transform: uppercase;
  letter-spacing: 0.07em;
  margin-bottom: 8px;
  padding-left: 4px;
  opacity: 0.6;
`;

export default function LegalScreen() {
  return (
    <Container>

      <Content>
        <Header>
          <h1>Wettelijke documentatie</h1>
        </Header>

        <InfoBanner>
          <span style={{ color: '#f97316', fontSize: 17, lineHeight: 1.3 }}>ⓘ</span>
          <span>
            U bent ingelogd bij <strong>KMFC Shop</strong>. Dit is een op maat gemaakt project. De documentatie kan afwijken van de standaardvoorwaarden van Webvonk. Neem contact met ons op voor meer informatie en de wettelijke documentatie.
          </span>
        </InfoBanner>

        <SectionLabel>Contactgegevens</SectionLabel>
        <Card>
          <Row>
            <RowLabel>Platform</RowLabel>
            <RowValue>Mijn Webvonk v2.0</RowValue>
          </Row>
          <Row>
            <RowLabel>E-mail</RowLabel>
            <RowValue><EmailLink href="mailto:info@webvonk.com">info@webvonk.com</EmailLink></RowValue>
          </Row>
          <Row>
            <RowLabel>Website</RowLabel>
            <RowValue><EmailLink href="https://webvonk.com" target="_blank" rel="noreferrer">webvonk.com</EmailLink></RowValue>
          </Row>
        </Card>
      </Content>
    </Container>
  );
}
